var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v(" Powered by SOFT TEAM Consulting v. "+_vm._s(this.version)+" "+_vm._s(this.signal)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }